import React from "react";

import { createRouter } from "@randajan/jet-react/dom/router";

import { E404 } from "../frames/Errors/E404/E404";
import { LadingPage } from "./LadingPage/LadingPage";
//import { LeaderBoard } from "./LeaderBoard/LeaderBoard";
//import { ThemesShow } from "./ThemesShow/ThemesShow";
//import { MiniGames } from "./MiniGames/MiniGames";

import { Me } from "./Me/Me";
import { Whois } from "./Whois/Whois";
import { Wiki } from "./Wiki/Wiki";
import { Partnerships } from "./Partnerships/Partnerships";
import { AboutUs } from "./AboutUs/AboutUs";
//import { Gallery } from "./Gallery/Gallery";
import { setupTitle } from "../assets/bases/page";
import { LoginFailed } from "../frames/Errors/LoginFailed/LoginFailed";
import { Events } from "./Events/Events";
import { Community } from "./Community/Community";
//import { Shop } from "./Shop/Shop";
//import { Game } from "./Game/Game";

const pages = [
  { title:"", path:"/", content:<LadingPage/>, menuId:"navHome", group:"main" },
  { titleId:"navProfile", path:"/me", content:<Me/> },
  { titleId:"navWiki", path:"/wiki", content:<Wiki/>, menuId:"navWiki", group:"main" },
  { titleId:"navCommunity", path:"/community", content:<Community/>, menuId:"navCommunity", group:"main" },
  { titleId:"navWhois", path:"/whois/:aliasKey", content:<Whois/> },
  { titleId:"navEvents", title:"Eventy", path:"/events{/:eventId}", link:"/events", content:<Events/>, menuId:"navEvents", group:"main" },
  //{ title:"Obchod", path:"/shop", content:<Shop/>, menu:"Obchod" },
  //{ title:"Game", path:"/game/:spaceId", content:<Game/> },
  //{ title:"Themes", path:"/themes/:themeId?", content:<ThemesShow/> },
  { titleId:"navPartnerships", path:"/partnerships", content:<Partnerships/>, menuId:"navPartnerships", group:"secondary" },
  { titleId:"navAbout", path:"/aboutUs", content:<AboutUs/>, menuId:"navAbout", group:"secondary" },
  //{ titleId:"navGallery", title:"Galerie", path:"/gallery", content:<Gallery/>, menuId:"navGallery", menu:"Galerie" },
  //{ title:"Mini Games", path:"/minigames", content:<MiniGames/> },
  { titleId:"navLoginFailed", path:"/login/failed", content:<LoginFailed/> },
  { titleId:"navE404", title:"404", path:"/*any", content:<E404/> }
];

export const Router = createRouter(pages);

setupTitle(Router);
